var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "footer--reinsurance"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "footer--reinsurance-phone footer-border-right col"
  }, [_c('Phone', {
    attrs: {
      "is-scramble-link": _vm.isScrambleLink
    }
  })], 1), _vm._v(" "), _vm.defaultShowcase ? _c('li', {
    staticClass: "footer--reinsurance-payment col"
  }, [_c('Payment', {
    attrs: {
      "is-scramble-link": _vm.isScrambleLink
    }
  })], 1) : _vm.locale.iso === 'es-ES' ? _c('li', {
    staticClass: "footer--reinsurance-delivery col"
  }, [_c('Delivery', {
    attrs: {
      "is-scramble-link": _vm.isScrambleLink
    }
  })], 1) : _c('li', {
    staticClass: "footer--reinsurance-faq col"
  }, [_c('Faq', {
    attrs: {
      "is-scramble-link": _vm.isScrambleLink
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "sep w-100 d-lg-none"
  }), _vm._v(" "), _vm.defaultShowcase ? _c('li', {
    staticClass: "footer--reinsurance-return footer-border-right col"
  }, [_c('Return', {
    attrs: {
      "is-scramble-link": _vm.isScrambleLink
    }
  })], 1) : _vm._e(), _vm._v(" "), !_vm.defaultShowcase && _vm.locale.iso !== 'en-GB' ? _c('li', {
    staticClass: "footer--reinsurance-payment col"
  }, [_c('Payment', {
    attrs: {
      "is-scramble-link": _vm.isScrambleLink
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.defaultShowcase ? _c('li', {
    staticClass: "footer--reinsurance-delivery col"
  }, [_c('Delivery', {
    attrs: {
      "is-scramble-link": _vm.isScrambleLink
    }
  })], 1) : _c('li', {
    staticClass: "footer--reinsurance-payment col",
    class: {
      'footer-border-right': _vm.locale.iso === 'en-GB'
    }
  }, [_c('Return', {
    attrs: {
      "is-scramble-link": _vm.isScrambleLink
    }
  })], 1), _vm._v(" "), _vm.locale.iso === 'en-GB' ? _c('li', {
    staticClass: "col"
  }, [_c('TrustPilot', {
    attrs: {
      "is-scramble-link": _vm.isScrambleLink
    }
  })], 1) : _vm._e()])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };